// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._25CrY{padding-bottom:1.5rem;border-bottom:1px solid #dcdddd;margin-bottom:1.5rem}._3doHT{display:grid;grid-row-gap:1.5rem}@media(min-width:768px){._3doHT{grid-column-gap:1rem;grid-row-gap:2.5rem}}@media(min-width:768px)and (max-width:1023px){._3doHT{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(min-width:1024px)and (max-width:1439px){._3doHT{grid-template-columns:repeat(3,minmax(0,1fr))}}@media(min-width:1440px){._3doHT{grid-template-columns:repeat(4,minmax(0,1fr))}}._2-FXj{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;grid-gap:8px;gap:8px;grid-gap:.5rem;gap:.5rem;padding-top:1.5rem}._2TDWM{-o-object-fit:cover;object-fit:cover;border-radius:50%;width:54px;width:3.375rem;height:54px;height:3.375rem}._1iO9R{padding:.75rem 0 2.25rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"title": "_25CrY",
	"contentWrapper": "_3doHT",
	"instructor": "_2-FXj",
	"avatar": "_2TDWM",
	"seeMore": "_1iO9R"
};
module.exports = exports;
